import "./styles.css";

export default function App() {
  return (
    <>
      <h2>Der morgen</h2>
      <h1>naht</h1>
      <h3>under contruction</h3>
    </>
  );
}
